import type { KeyboardEvent } from "react";

// Fires `callback` on Enter/Space, mirroring native <button> activation —
// needed for non-native elements (divs) acting as tabs/rows, which carry
// custom hover/selected styling that a real <button>/<a> would fight.
export function handleActivationKey(e: KeyboardEvent, callback: () => void) {
	if (e.key === "Enter" || e.key === " ") {
		e.preventDefault();
		callback();
	}
}
